import { createAction, createReducer } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'

const intangibleAssetsRequested = createAction('intangibleAssets/requested')
const intangibleAssetsReceived = createAction('intangibleAssets/received')
const intangibleAssetsFailed = createAction('intangibleAssets/failed')

export const initialState = {
  loading: false,
  data: null
}

const intangibleAssetsReducer = createReducer(initialState, {
  [intangibleAssetsRequested.type]: (state) => {
    state.loading = true
  },
  [intangibleAssetsReceived.type]: (state, action) => {
    state.loading = false
    state.data = action.payload.data
  },
  [intangibleAssetsFailed.type]: (state, action) => {
    state.loading = false
    toast.error(action.payload.message)
  }
})

export default intangibleAssetsReducer

export const loadIntangibleAssetsPreview = () => (dispatch, getState) => {
  const currentState = getState()
  const id = gameIdSelector(currentState)
  dispatch(
    apiCallBegan({
      url: `games/${id}/intangible_assets/preview`,
      onStart: intangibleAssetsRequested.type,
      onSuccess: intangibleAssetsReceived.type,
      onError: intangibleAssetsFailed.type
    })
  )
}
